module.exports = __webpack_public_path__ + "img/58.ea16a700.jpg";